export const ALLOWED_SIGNATURE_MIME_TYPES = ['image/jpeg', 'image/png'] as const

export const ALLOWED_SIGNATURE_ACCEPT = 'image/jpeg,image/png,.jpg,.jpeg,.png'

const ALLOWED_SIGNATURE_EXTENSIONS = ['jpg', 'jpeg', 'png']

export const isAllowedSignatureFile = (file: File): boolean => {
  if (
    ALLOWED_SIGNATURE_MIME_TYPES.includes(
      file.type as typeof ALLOWED_SIGNATURE_MIME_TYPES[number]
    )
  ) {
    return true
  }

  const extension = file.name.split('.').pop()?.toLowerCase()
  return ALLOWED_SIGNATURE_EXTENSIONS.includes(extension || '')
}
